"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var core_1 = require("@athena-portal/core");
var Section = /** @class */ (function (_super) {
    __extends(Section, _super);
    function Section(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            widgets: _this.widgetsManager.getFilteredWidgets(core_1.WidgetFilter.bySection(_this.props.id))
        };
        _this.widgetsManager.on(core_1.WidgetsEvent.Change, _this.loadWidgets.bind(_this));
        return _this;
    }
    Section.prototype.render = function () {
        var _this = this;
        var className = "".concat(this.props.className || "", " ").concat(this.state.widgets.length > 0 ? "" : "collapsed");
        return (React.createElement("div", { className: className },
            React.createElement("div", { className: "section-wrap" }, this.state.widgets.map(function (widget) {
                return React.createElement(widget.component, Object.assign({ key: widget.id }, Object.assign(widget.metadata || {}, _this.props.propsProvider ? _this.props.propsProvider() : {})));
            }))));
    };
    /**
     * Update state by refreshing widgets
     */
    Section.prototype.loadWidgets = function () {
        var widgets = this.widgetsManager.getFilteredWidgets(core_1.WidgetFilter.bySection(this.props.id));
        this.setState({
            widgets: widgets
        });
    };
    __decorate([
        (0, core_1.lazyInject)(core_1.TypeDefs.WidgetsManager),
        __metadata("design:type", Object)
    ], Section.prototype, "widgetsManager", void 0);
    return Section;
}(React.Component));
exports.default = Section;
//# sourceMappingURL=Section.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/components/dist/Section.js
// module id = 607
// module chunks = 0